export class PostedClaimReversal {
    constructor(
        public RawDataImport_ShardClaimIdentifier: number) {}
}



// WEBPACK FOOTER //
// ./src/app/models/postedClaimReversal.model.ts